import React, {Component} from 'react';
import {
    Button, Modal, ModalHeader, ModalBody, ModalFooter, Col, FormGroup, Input, Label
} from 'reactstrap';
import {toast} from 'react-toastify';

import ErrorMsg from "../common/ErrorMsg";
import { MONTH_LIST, WEEK_DAYS, getMonthlyWeekDay } from "./Constants";


const EMPTY_HOLIDAY = {
    id: '',
    name: '',
    default_date: '01-01',
    has_fixed_date: true,
    week_no: 1,
    day: 1,
    month: 1,
    location_list: []
};

export default class HolidayForm extends Component {
    state = {
        holiday: {...EMPTY_HOLIDAY},
        errors: {name: ''},
        locationList: [],
    }

    componentDidMount = () => {
        let {locationList} = this.props;
        let updatedLocationList = locationList.map(location => {
            if (location.id === Number(this.props.agencyLocation)) {
                return {...location, checked: true};
            } else {
                return {...location, checked: false};
            }
        });
        this.setState({
            locationList: updatedLocationList,
            holiday: {...this.props.selectedHoliday}
        });
    }

    handleDate = (e) => {
        let name = e.target.name;
        let value = e.target.value;
        const {holiday} = this.state;
        let splitedDate = holiday.default_date.split('-');
        if (name === "month") {
            this.setState({holiday: {
                ...holiday,
                default_date: `${Number(value)}-${splitedDate[1] ? Number(splitedDate[1]) : 1}`
            }})
        } else {
            this.setState({holiday: {
                ...holiday,
                default_date: `${splitedDate[0] ? Number(splitedDate[0]) : 1}-${Number(value)}`
            }})
        }
    }

    onChange = (event) => {
        let name = event.target.name;
        let value = event.target.value;
        this.setState({
            holiday: {...this.state.holiday, [name]: value}
        }, () => this.validateHoliday(name, value));
    };

    //validate holiday
    validateHoliday = (field, value) => {
        const errors = {...this.state.errors};
        if(!(/^\(?([A-Za-z0-9][A-Za-z0-9 ,.'-/\"&`%$():_]{0,99})$/.test(value))){
            errors['name'] = 'Allowed characters are (A-Z a-z 0-9 ,.\'-/"&`%$():_) and must start with alphanumeric.';
        }
        else if (!value.trim()) {
            errors['name'] = 'This field is required.'
        } else {
            errors['name'] = ''
        }
        this.setState({errors});
        return true;
    };

    toggleLocationCheck = (location) => {
        if ("checked" in location) {
            location["checked"] = !location["checked"];
        } else {
            location["checked"] = true;
        }
        
        let {locationList} = this.state;
        let newLocationList = locationList.map(orgLocation => {
            if (location.id === orgLocation.id) {
                return location;
            }
            return orgLocation;
        });
        
        this.setState({locationList: newLocationList});
    }

    renderDateOptions = (monthNo) => {
        let dayOptions = [];
        for (let d = 1; d <= MONTH_LIST[monthNo-1].noOfDays; d++) {
            dayOptions.push(
                <option key={d} value={d}>{("0"+d).slice(-2)}</option>
            )
        }
        return dayOptions;
    }
    
    renderMonthOptions = () => {
        return MONTH_LIST.map((month, index) => 
            <option key={index} value={month.monthNo}>{month.month}</option>
        );
    }

    renderLocations = () => {
        return this.state.locationList.map((location) => 
            <div className="mb-2 form-check" key={location.id}>
                <label className="form-check-label position-relative">
                    <Input type="checkbox" className="form-check-input my-0" 
                        value={location.checked} 
                        checked={location.checked} 
                        onChange={() => this.toggleLocationCheck(location)} 
                    /> &nbsp; 
                    {location.name}
                </label>
            </div>
        )
    }

    saveDefaultHoliday = async () => {
        // e.preventDefault();
        const {locationList, holiday} = this.state;
        const {year} = this.props;

        let selectedLocationList = [];
        locationList.map(location => {
            if(location.checked) {
                selectedLocationList.push(location.id);
            }
            return location;
        });
        
        let reqHolidayObj = {
            ...holiday,
            location_list: selectedLocationList
        }
        try {
            if (!reqHolidayObj.has_fixed_date) {
                let date = getMonthlyWeekDay(
                    reqHolidayObj.week_no, reqHolidayObj.day, reqHolidayObj.month,
                    year ? year : new Date().getFullYear()
                )
                if(date) {
                    reqHolidayObj.default_date = `${date.month() + 1}-${date.date()}`
                }
            }
            
            let result;
            if (reqHolidayObj.id) {
                reqHolidayObj.agency_location = this.props.agencyLocation;
                result = await this.props.updateHoliday(reqHolidayObj);
            } else {
                result = await this.props.AddHoliday(this.props.agencyLocation, reqHolidayObj);
            }
            if (result) {
                toast.success("Saved Successsfully.");
                this.props.toggleModal();
            }
        } catch(error) {
            toast.error(<ErrorMsg errors={error} />);
        }
    };

    handleDateChangeRaw = (event) => {
		event.preventDefault();
	};

    render() {
        const {holiday, errors, locationList} = this.state;
        let splitedDate = holiday.default_date.split('-');
        let month = splitedDate[0] ? Number(splitedDate[0]) : 1;
        let date = splitedDate[1] ? Number(splitedDate[1]) : 1;

        return (
            <Modal isOpen={this.props.modal} toggle={this.props.toggleModal}>
                <ModalHeader toggle={this.props.toggleModal}>
                    {holiday.id ? "Edit" : "Add"} Holiday
                </ModalHeader>
                <ModalBody>
                    <FormGroup row className="mb-1">
                        {locationList.length > 1 && !holiday.id &&
                            <Col sm={4}>
                                <Label className="mb-0">Select Locations</Label>
                                <div className="bg-white p-2">
                                    {this.renderLocations()}
                                </div>
                            </Col>
                        }
                        <Col sm={locationList.length > 1 && !holiday.id ? 8 : 12}>
                            <FormGroup row>
                                <Col sm={locationList.length > 1 && !holiday.id ? 12 : 6} 
                                    className="mb-2"
                                >
                                    <Label className="mb-0">Name</Label>
                                    <Input type="text" name="name" 
                                        value={holiday.name}
                                        onChange={this.onChange} 
                                        maxLength={100}
                                        autoFocus={true}
                                    />
                                    {errors.name &&
                                        <span className="span-error"> 
                                            {errors.name}
                                        </span> 
                                    }
                                </Col>
                                <Col sm={locationList.length > 1 && !holiday.id ? 12 : 6}
                                    className="mb-2"
                                >
                                    <br/>
                                    <Label className="mb-0 d-flex align-items-center">
                                        <Input type="checkbox" 
                                            className="m-0 position-relative cursor-pointer" 
                                            value={holiday.has_fixed_date} 
                                            checked={holiday.has_fixed_date} 
                                            onChange={() => this.setState({
                                                holiday: {
                                                    ...holiday, 
                                                    has_fixed_date: !holiday.has_fixed_date
                                                }
                                            })} 
                                        /> &nbsp; has fixed date ?
                                    </Label>
                                </Col>
                                <Col sm={locationList.length > 1 && !holiday.id ? 12 : 6} 
                                    className="mb-2"
                                >
                                    <Label className="mb-0">Date</Label>
                                    {holiday.has_fixed_date ? 
                                        <div className="d-flex">
                                            <select name="month" className="form-control w-50"
                                                value={month} onChange={this.handleDate}
                                            >
                                                {this.renderMonthOptions()}
                                            </select>
                                            <select name="date" className="form-control w-50"
                                                value={date} onChange={this.handleDate}
                                            >
                                                {this.renderDateOptions(month)}
                                            </select>
                                        </div>
                                        :
                                        <div className="d-flex">
                                            <select className="form-control w-30"
                                                value={holiday.week_no} 
                                                onChange={(e) => this.setState({
                                                    holiday: {
                                                        ...holiday,
                                                        week_no: Number(e.target.value)
                                                    }
                                                })}
                                            >
                                                <option value={1}>1st</option>
                                                <option value={2}>2nd</option>
                                                <option value={3}>3rd</option>
                                                <option value={4}>4th</option>
                                                <option value={5}>Last</option>
                                            </select>
                                            <select className="form-control w-30"
                                                value={holiday.day} 
                                                onChange={(e) => this.setState({
                                                    holiday: {
                                                        ...holiday,
                                                        day: Number(e.target.value)
                                                    }
                                                })}
                                            >
                                                {WEEK_DAYS.map((week, index) => 
                                                    <option key={index} value={index}>
                                                        {week}
                                                    </option>
                                                )}
                                            </select>
                                            <select className="form-control w-40"
                                                value={holiday.month} 
                                                onChange={(e) => this.setState({
                                                    holiday: {
                                                        ...holiday,
                                                        month: Number(e.target.value)
                                                    }
                                                })}
                                            >
                                                {this.renderMonthOptions()}
                                            </select>
                                        </div>
                                    }
                                    {errors.default_date &&
                                        <span className="span-error"> 
                                            {errors.default_date}
                                        </span> 
                                    }
                                </Col>
                            </FormGroup>
                        </Col>
                    </FormGroup>
                </ModalBody>
                <ModalFooter>
                    <Button color="success" onClick={this.saveDefaultHoliday}>
                        Save
                    </Button>
                    <Button color="secondary" onClick={this.props.toggleModal}>
                        Close
                    </Button>
                </ModalFooter>
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/pto/HolidayForm.js